import React, { useEffect } from 'react'
import Head from 'next/head'

import Header from '@/partials/Header'
import Footer from '@/partials/FooterOLD2'
import TutorialsList from '@/partials/TutorialsList'
import Newsletter from '@/partials/Newsletter'
import YoutubeTutorialsList from '@/partials/YoutubeTutorialsList'
import TemplateNewsletter from '@/components/Templates/Index/TemplaeNewsletter'
import TemplatesList from '@/components/Templates/Index/TemaplatesList'
import { useRouter } from 'next/router'
import TemplatesDetails from '@/components/Templates/Details/TemplatesDetails'
import { getUserDetails, get_tenant_configs } from '../api/api'
import { getAuthKey, getSSRAuthKey, getSSRSelectedTenantDetails } from 'constant/functions'
import { api_call, api_call_with_auth_key } from '@/WebHandler/api_call'
import { tradly_api_call } from '@/WebHandler/tradly_api_call'
import axios from 'axios'
import { auth_cookie_name } from 'constant/url'
import socialCardLarge from '@/img/tradly/Tradly MEta image.png'
import TradlyFooter from '@/partials/TradlyFooter'
import { useAppContext } from '@/context_store/AppContext'
import { select_domain, set_all_sites } from '@/context_store/actions'

function TemplateDetails({ user_details, tenant_details, template_details, sites_list }) {
  const router = useRouter()
  // context
  const { state, dispatch } = useAppContext()
  // workspaces
  useEffect(() => {
    if (sites_list && sites_list?.length > 0) {
      dispatch(select_domain(sites_list[0]))
      dispatch(set_all_sites(sites_list))
    }
  }, [router])

  return (
    <>
      <Head>
        <title>
          {template_details?.listing?.meta_title
            ? template_details?.listing?.meta_title
            : template_details?.listing?.title}
        </title>
        <meta
          name="description"
          content={
            template_details?.listing?.meta_description
              ? template_details?.listing?.meta_description
              : template_details?.listing?.description
          }
        />
        <meta
          name="keywords"
          content={
            template_details?.listing?.meta_keyword
              ? template_details?.listing?.meta_keyword
              : template_details?.listing?.title
          }
        />
        <meta
          property="og:title"
          content={
            template_details?.listing?.meta_title
              ? template_details?.listing?.meta_title
              : template_details?.listing?.title
          }
          key="title"
        />
        <meta
          key="twitter:title"
          name="twitter:title"
          content={`${
            template_details?.listing?.meta_title
              ? template_details?.listing?.meta_title
              : template_details?.listing?.title
          }`}
        />
        <meta
          key="twitter:description"
          name="twitter:description"
          content={
            template_details?.listing?.meta_description
              ? template_details?.listing?.meta_description
              : template_details?.listing?.description
          }
        />
        <meta
          key="twitter:image"
          name="twitter:image"
          content={
            template_details?.listing?.images?.length > 0
              ? template_details?.listing?.images[0]
              : `https://tradly.app${socialCardLarge}`
          }
        />

        <meta key="og:type" property="og:type" content="website" />
        <meta
          key="og:description"
          property="og:description"
          content={
            template_details?.listing?.meta_description
              ? template_details?.listing?.meta_description
              : template_details?.listing?.description
          }
        />
        <meta
          key="og:image"
          property="og:image"
          content={
            template_details?.listing?.images?.length > 0
              ? template_details?.listing?.images[0]
              : `https://tradly.app${socialCardLarge}`
          }
        />
      </Head>
      <div className="flex flex-col min-h-screen ">
        <main className="flex-grow">
          {/*  Page sections */}
          <TemplatesDetails
            user_details={user_details}
            tenant_details={tenant_details}
            template_details={template_details}
          />
        </main>

        {/*  Site footer */}
        <TradlyFooter />
      </div>
    </>
  )
}

export default TemplateDetails

export async function getServerSideProps({ params, req, res }) {
  const { template_slug } = params

  const auth_key = getSSRAuthKey(req.cookies[auth_cookie_name])
  const user_details = await getUserDetails(auth_key)
    .then((res) => {
      return res.user
    })
    .catch((error) => {
      console.log(error)
      return {}
    })

  const tenant_details = await api_call_with_auth_key({
    method: 'GET',
    path: '/skua/tenants/users_tenants',
    data: {},
    auth_key,
    onSuccess: (res) => {
      return getSSRSelectedTenantDetails({ tenants: res.tenants, req: req })
    },
    onError: (err) => {
      console.log(err)
      return {}
    },
  })

  const template_details = await tradly_api_call({
    method: 'GET',
    path: `/products/v1/listings/by_slug/${template_slug}`,
    data: {},
  })
    .then((res) => {
      return res
    })
    .catch((error) => {
      console.log(error)
      return {}
    })

  const sites_list = await api_call_with_auth_key({
    method: 'GET',
    path: `/skua/tenants/domains`,
    data: {},
    auth_key,
    onSuccess: (res) => {
      return res?.tenant_domains
    },
    onError: (err) => {
      console.log(err)
      return {}
    },
  })

  return {
    props: { user_details, tenant_details, template_details, sites_list },
  }
}
